import { useEffect } from 'react';

export const useOutsideClick = (ref, onOutsideClick, show) => {
  const handleClickOutside = event => {
    if (ref.current && !ref.current.contains(event.target)) {
      onOutsideClick(event);
    }
  };

  useEffect(() => {
    if (show) {
      document.addEventListener('click', handleClickOutside, true);
      return () => {
        document.removeEventListener('click', handleClickOutside, true);
      };
    }
  }, [show]); // eslint-disable-line
};
